import React from "react";
import PropTypes from "prop-types";
import { useDynamicSvgImport } from "@/utility/dynamicSVGImport";

interface IProps {
  children?: React.ReactNode;
  iconName: string;
  onClick?: React.MouseEventHandler;
  wrapperStyle?: string;
  svgProp?: React.SVGProps<SVGSVGElement>;
}

const props = {
  children: PropTypes.node,
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  wrapperStyle: PropTypes.string,
  svgProp: PropTypes.object,
};

function Icon(props: IProps) {
  const { children, iconName, onClick, wrapperStyle, svgProp } = props;
  const { error, loading, SvgIcon } = useDynamicSvgImport(iconName);

  return (
    <>
      {
        loading && (
          <div className="tw-rounded-lg tw-opacity-0 tw-bg-slate-400 tw-animate-pulse-delayed tw-h-8 tw-w-8"></div>
        )
      }
      {
        !error && !loading && (
          <button className={`tw-flex tw-justify-center tw-items-center ${onClick?'tw-cursor-pointer':'tw-cursor-default'} ${wrapperStyle}`} onClick={onClick} tabIndex={onClick?0:-1}>
            {SvgIcon && <SvgIcon {...svgProp} />}
            { children }
          </button>
        ) 
      }
    </>
  );
}

Icon.propTypes = props;

export default Icon;
